OWL_CAROUSEL = {
    messages: {
        next: "${ACCUEIL_CAROUSEL_SUIVANT}",
        previous: "${ACCUEIL_CAROUSEL_PRECEDENT}"
    }
};
